import { useQuery } from '@hooks/reactQuery';

import { getOrganisationRoles } from '@api/common';

import { IOrganisationDataParams } from '@interfaces/organisation/organisations';

import { IOrganisationRoleInterface } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_ROLES } from '@constants/queryKeys';

export const useQueryOrganisationRoles = (params: IOrganisationDataParams) => {
	const { organisationTypesForRoles, isActiveQuery } = params;

	const {
		data: organisationRoles,
		isLoading: isLoadingRoles,
		isFetching: isFetchingRoles,
	} = useQuery<IOrganisationRoleInterface[]>({
			queryKey: [ORGANISATION_ROLES, organisationTypesForRoles],
			queryFn: () => getOrganisationRoles(organisationTypesForRoles!),
			enabled: [!!organisationTypesForRoles?.length, isActiveQuery],
			...refetchOptions,
		},
	);

	return {
		isLoadingOrganisationRoles: (isActiveQuery && organisationTypesForRoles?.length)
			? (isLoadingRoles || isFetchingRoles) : false,
		organisationRoles: organisationRoles || [],
	};
};
